import * as THREE from "three";
import VisComp from "@three-extra/VisComp";
import typeManager from "@cloud/TypeManager";

/*
    // VisComp /////////////////////////////////////////////
	
	this.scene ( SceneSingle )
	- our class to manage to scene

	this.cont3D ( Group )
	- add all your visual stuff to this
	- it already contains the Lights - /if VisComp has any
	
	this.renderer ( RenderComp )
	- our rendering component
	- THREE.Renderer is inside

	this.me ( Me )
	- representation of the user
	- camera is inside

*/

/*
	// Arthurs custom parameters:
	count : int
	dimX : float
    geom : Pattern<Geometry>
    mat : Pattern<Material>
*/

// Let's try to make a particle system

class GridHelper extends VisComp {
  constructor() {
    super();
  }

  start() {
    super.start();

    const gridHelper = new THREE.GridHelper(
      this.inputs.get("size"),
      this.inputs.get("divisions"),
      this.inputs.get("colorCenterLine"),
      this.inputs.get("colorGrid")
    );
    this.cont3D.add(gridHelper);
  }
  update(dt) {
    super.update(dt);
  }
}

typeManager.registerClass("606492f0d921850017211425", GridHelper);

export default GridHelper;
